export default {
    name: "Home",

    data: () => ({

    })
};
